export const CORE_AXIOS_PATH = 'v2/core';
